import { render } from "./WSaldo.vue?vue&type=template&id=72013358&scoped=true"
import script from "./WSaldo.vue?vue&type=script&lang=js"
export * from "./WSaldo.vue?vue&type=script&lang=js"

import "./WSaldo.vue?vue&type=style&index=0&id=72013358&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72013358"]])

export default __exports__